import TeSubMenu from './template.vue';


TeSubMenu.install = function(Vue) {
  Vue.component(TeSubMenu.name, TeSubMenu);
};

export default TeSubMenu;